import React from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { Raffle, style } from '../../api';

import { TextBold10 } from './Text';

export type BadgeProps = {
  textColor?: string;
  backgroundColor: string;
};

const Badge = styled.div`
  background-color: ${(props: BadgeProps) => props.backgroundColor};
  padding: 2px 9px 2px 9px;
  border-radius: 3px;
  ${TextBold10} {
    display: block;
    color: ${(props: BadgeProps) => props.textColor || style.black_new};
  }
`;

export type RaffleBadgeProps = {
  raffle: Pick<Raffle, 'status' | 'winner'>;
};

const RaffleBadge: React.FC<
  RaffleBadgeProps &
    React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >
> = ({ raffle, ...rest }: RaffleBadgeProps) => {
  const { t } = useTranslation('contests');
  if (raffle.winner?.winner_id) {
    return (
      <Badge backgroundColor={style.info_new} textColor="#fff" {...rest}>
        <TextBold10>{t('contests:winnerAnnounced')}</TextBold10>
      </Badge>
    );
  }

  if (raffle.status === 'closed') {
    return (
      <Badge
        backgroundColor={style.warning_new}
        textColor={style.black_new}
        {...rest}
      >
        <TextBold10>{t('contests:WinnerTBA')}</TextBold10>
      </Badge>
    );
  }

  return null;
};

export default RaffleBadge;
